import _                  from 'lodash'
import Immutable          from 'immutable'
import { delegate, wrap } from 'alto-utils/lib/macros'

class Association
  constructor: (@name, @backendName, @sourceModel, @destinationModel, @foreignKey) ->

  toString: ->
    "#{@constructor.name} { name: #{@name}, sourceModel: #{@sourceModel.name}, " +
    "destinationModel: #{@destinationModel.name}, foreignKey: #{@foreignKey} }"

export class BelongsTo extends Association
export class HasMany extends Association
export class HasOne extends Association

export class HasManyThrough
  constructor: (@name, @sourceModel, @assocNames) ->

export class AssociationCollection
  constructor: (associations = []) ->
    @associations = new Immutable.Set(associations)

  delegate(@, 'map', 'forEach', 'find', to: 'associations')

  add: (association) ->
    new @constructor(@associations.add(association))

  merge: (other) ->
    new @constructor(@associations.union(other.associations))

  findBy: (sourceModel, name) ->
    @associations.find (assoc) -> assoc.name == name and assoc.sourceModel == sourceModel

  forModel: (sourceModel) ->
    new @constructor(@associations.filter (assoc) -> assoc.sourceModel == sourceModel)

  ofType: (type) ->
    new @constructor(@associations.filter (assoc) -> assoc instanceof type)

  backendPathFor: (sourceModel, path) ->
    chain      = @_chainForPath(sourceModel, path)
    names      = _.map(chain, 'backendName')
    separators = path.match(/\.|\|/g)

    _.compact(_.flatten(_.zip(names, separators))).join('')

  finalModelFor: (sourceModel, path) ->
    chain = @_chainForPath(sourceModel, path)

    _.last(chain).destinationModel

  destinationModelsForPaths: (sourceModel, paths) ->
    associations = @_uniqueForPaths(sourceModel, paths)

    _.uniq(_.map(associations, 'destinationModel'))

  _uniqueForPaths: (sourceModel, paths) ->
    chains = @_chainsForPaths(sourceModel, paths)

    _.uniq(_.concat(chains...))

  _chainsForPaths: (sourceModel, paths) ->
    paths.map (path) => @_chainForPath(sourceModel, path)

  _chainForPath: (sourceModel, path) ->
    associations = []

    for name in _.split(path, /\.|\|/)
      association = @findBy(sourceModel, name)

      throw Error("association for #{sourceModel.name}.#{name} not found") unless association

      associations.push(association)
      sourceModel = association.destinationModel

    associations
